export const MODAL_NAMES = {
  CREATE: 'options.integrations.create',
  DELETE: 'options.integrations.delete',
}
